import type { KeyType } from '../types/types'
import axios from 'axios'
import useLocalStorage from './useLocalStorage'

export default function useGlobalConfig() {
  const { user, globalConfig, selectedStore } = useLocalStorage()

  const typeResolver = {
    merchants: 'merchant',
    users: 'user',
    stores: 'store'
  }

  const configUrl = (type: KeyType) => {
    let id = null
    switch (type) {
      case 'users':
        id = user.value.id
        break
      case 'merchants':
        id = user.value.merchant.id
        break
      default:
        id = selectedStore.value
        break
    }
    const url = `/${type}/${id}/configs`
    return url
  }

  const updateKeys = async (type: KeyType, payload: unknown) => {
    const url = configUrl(type)
    const { data } = await axios.post(url, {
      data: payload
    })
    const realType = typeResolver[type]
    globalConfig.value[realType] = data.data
  }

  const getKeys = async (type: KeyType) => {
    try {
      const url = configUrl(type)
      const { data } = await axios.get(url)
      return data
    } catch {
      return {}
    }
  }

  const getKey = async (type: KeyType, key: string) => {
    try {
      const url = configUrl(type)
      const { data } = await axios.get(`${url}/${key}`)
      return data?.data?.[key]
    } catch {
      return null
    }
  }

  return {
    updateKeys,
    getKeys,
    getKey
  }
}
